module.exports = "././img/CoM_Secondary_a_white.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/CoM_Secondary_a_white.png
// module id = 810
// module chunks = 0